<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ARNI SCHOOL OF AGRICULTURE</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Agriculture</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<section class="pt-3">
    <div class="container">
        <h3 class="text-center text-primary">Courses</h3>
        <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Under Graduate</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">Bachelor of Science(Agriculture)</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <h5 class="text-decoration-underline text-center">Agriculture</h5>

        <div class="row">
            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Bachelor of Science (Agriculture) </b>
                    – The ARNI School of Agriculture's Bachelor of Science in Agriculture, or B.Sc. in Agriculture,
                    program covers agricultural science, technology, and management with the goal of giving students the
                    information and abilities they need to handle problems in the agricultural industry. There are eight
                    semesters in this four-year degree program.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester I</b> : Foundation</p>
                <ul>
                    <li> Fundamentals of Agronomy</li>
                    <li> Fundamentals of Soil Science</li>
                    <li> Fundamentals of Horticulture</li>
                    <li> Rural Sociology and Constitution of India</li>
                    <li> Basic Science and Humanities</li>
                    <li> Communication Skills in English</li>
                    <li> Elementary Mathematics or Basic Agriculture 2</li>
                    <li> Agricultural Heritage</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester II</b> : Core Concepts</p>
                <ul>
                    <li> Principles of Agricultural Economics</li>
                    <li> Fundamentals of Plant Biochemistry</li>
                    <li> Fundamentals of Entomology-I</li>
                    <li> Agricultural Economics</li>
                    <li> Soil Fertility and Fertilizers</li>
                    <li> Principles of Genetics and Plant Breeding</li>
                    <li> Agricultural Finance and Cooperation</li>
                    <li> Human Values & Ethics</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester III
                </b>: In-Depth Learning</p>
                <ul>
                    <li> Farm Power and Machinery</li>
                    <li> Agricultural Engineering</li>
                    <li> Agricultural Extension Education</li>
                    <li> Agricultural Microbiology</li>
                    <li> Principles of Integrated Disease Management</li>
                    <li> Environmental Studies & Disaster Management</li>
                    <li> Crop Production Technology 1</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester IV
                </b>: Core Technologies</p>
                <ul>
                    <li> Crop Production Technology II</li>
                    <li> Practical Crop Production 1</li>
                    <li> Principles of Seed Technology</li>
                    <li> Entrepreneurship Development and Business Communication</li>
                    <li> Organic Farming and Sustainable Agriculture</li>
                    <li> Food Processing and Preservation</li>
                    <li> Introductory Agro-meteorology & Climate Change</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester V
                </b>: Advanced Technologies</p>
                <ul>
                    <li> Intellectual Property Rights</li>
                    <li> Agricultural Marketing Trade & Prices</li>
                    <li> Communication Skills and Personality Development</li>
                    <li> Principles of Food Science & Nutrition</li>
                    <li> Protected Cultivation and Secondary Agriculture</li>
                    <li> Elective I</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester VI
                </b>: Industry Aligned Learning</p>
                <ul>
                    <li> Farming System, Precision Farming & Sustainable Agriculture</li>
                    <li> Dimensions of Agricultural Extension</li>
                    <li> Extension Methodologies for Transfer of Agricultural Technologies</li>
                    <li> Manures, Fertilizers and Soil Fertility Management</li>
                    <li> Watershed and Wasteland Management</li>
                    <li> Elective II</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester VII
                </b>: Research</p>
                <ul>
                    <li> Precision Agriculture</li>
                    <li> Seed Technology and Seed Production</li>
                    <li> Organic Farming and Certification</li>
                    <li> Soil, Plant, Water, and Seed Testing</li>
                    <li> Internship/Project</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester VIII
                </b>: Project and Seminar</p>
                <ul>
                    <li> Commercial Beekeeping</li>
                    <li> Mushroom Cultivation Technology</li>
                    <li> Production Technology for Bioagents and Biofertilizer</li>
                    <li> General Orientation</li>
                    <li> Project Report Preparation, Presentation, and Evaluation</li>
                </ul>
            </div>

        </div>

    </div>
</section>
